import { Box, Paper, ToggleButton, ToggleButtonGroup, useTheme } from '@mui/material';
import { RocketLaunch, Science } from '@mui/icons-material';

interface EnvironmentSwitcherProps {
  environment: 'staging' | 'prod';
  onChange: (environment: 'staging' | 'prod') => void;
}

export const EnvironmentSwitcher: React.FC<EnvironmentSwitcherProps> = ({ environment, onChange }) => {
  const theme = useTheme();

  const handleEnvironmentChange = (_event: React.MouseEvent<HTMLElement>, newEnvironment: 'staging' | 'prod' | null) => {
    if (newEnvironment !== null) {
      onChange(newEnvironment);
    }
  };

  return (
    <Paper elevation={0} sx={{ border: `1px solid ${theme.palette.divider}` }}>
      <ToggleButtonGroup
        value={environment}
        exclusive
        onChange={handleEnvironmentChange}
        size="small"
        sx={{
          '& .MuiToggleButton-root': {
            px: 2,
            py: 0.75,
            textTransform: 'none',
            fontWeight: 500,
            border: 'none',
            '&.Mui-selected': {
              bgcolor: environment === 'staging' ? theme.palette.primary.main + '15' : theme.palette.success.main + '15',
              color: environment === 'staging' ? theme.palette.primary.main : theme.palette.success.main,
              '&:hover': {
                bgcolor:
                  environment === 'staging' ? theme.palette.primary.main + '25' : theme.palette.success.main + '25',
              },
            },
          },
        }}
      >
        <ToggleButton value="staging">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Science fontSize="small" />
            Sandbox
          </Box>
        </ToggleButton>
        <ToggleButton value="prod">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <RocketLaunch fontSize="small" />
            Production
          </Box>
        </ToggleButton>
      </ToggleButtonGroup>
    </Paper>
  );
};

export default EnvironmentSwitcher;
